namespace advisorop.components.advisor {

    export class AppTrackerAdvisorController {

        filterByAdvisor = false;
        includeProposedAmount = false;

        constructor() { }

        $routerOnActivate(next, prev) {
            if (next.params.filterByAdvisor) {
                this.filterByAdvisor = next.params.filterByAdvisor == '1';
            }
            if (next.params.includeProposedAmount) {
                this.includeProposedAmount = next.params.includeProposedAmount == '1';
            }
        }
    }

    class AppTrackerAdvisor implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {};
            this.controller = ["advisorService", AppTrackerAdvisorController];
            this.controllerAs = "vm";
            this.templateUrl = "spa/advisor-module/components/app-tracker-advisor.html";
        }
    }
    angular.module(Constants.APP).component("appTrackerAdvisor", new AppTrackerAdvisor());
}